/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Suggestions_Prompt_2Inputs */

const es_chat_suggestions_prompt_2 = /** @type {(inputs: Chat_Suggestions_Prompt_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumir archivos de la semana pasada`)
};

const en_chat_suggestions_prompt_2 = /** @type {(inputs: Chat_Suggestions_Prompt_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summarize files from last week`)
};

/**
* | output |
* | --- |
* | "Summarize files from last week" |
*
* @param {Chat_Suggestions_Prompt_2Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_suggestions_prompt_2 = /** @type {((inputs?: Chat_Suggestions_Prompt_2Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestions_Prompt_2Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_suggestions_prompt_2(inputs)
	return en_chat_suggestions_prompt_2(inputs)
});
export { chat_suggestions_prompt_2 as "chat.suggestions.prompt_2" }